import React, { useState, useEffect } from 'react'

import { Table, TableHead, TableBody, TableRow, TableCell, TextField, Typography } from '@material-ui/core'

export const PlacementIdTable = ({ path, options, allOptions, setOptions, setAllOptions, errors, setErrors, validation }) => {
  const { PREBID } = options
  const { STRING } = validation
  const { LENGTH } = STRING
  const [source, setSource] = useState([])

  const getProperty = (path) => {
    const keys = path.split(/\./)
    const lastIndex = keys.length - 1
    const lastKey = keys[lastIndex]
    let property = PREBID.VENDOR

    keys.forEach((key, index) => {
      if (!property[key]) { property[key] = {} }
      if (index < lastIndex) { property = property[key] }
    })

    return property[lastKey]
  }

  useEffect(() => {
    setSource(getProperty(path))
  }, [getProperty(path)])

  return (
    <>
      <Table size='small' aria-label='placement-id-table'>
        <TableHead>
          <TableRow>
            <TableCell />
            <TableCell colSpan={2} style={{ textAlign: 'center' }}>DOMESTIC</TableCell>
            <TableCell colSpan={2} style={{ textAlign: 'center' }}>INTERNATIONAL</TableCell>
          </TableRow>
          <TableRow>
            <TableCell style={{ width: '180px' }}><Typography variant='h6' style={{ fontWeight: 'bolder' }}>Placement IDs</Typography></TableCell>  
            <TableCell style={{ textAlign: 'center' }}>HP</TableCell>
            <TableCell style={{ textAlign: 'center' }}>ROS</TableCell>
            <TableCell style={{ textAlign: 'center' }}>HP</TableCell>
            <TableCell style={{ textAlign: 'center' }}>ROS</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell style={{ width: '180px' }}><Typography variant='h6' style={{ fontWeight: 'normal' }}>Desktop</Typography></TableCell>
            <TableCell style={{ textAlign: 'center' }}>
              <TextField
                margin='none'
                value={source.DOM?.DESKTOP?.HP || ''}
                error={errors.PREBID_PLACEMENT_DOM_HP_DESKTOP}
                helperText={errors.PREBID_PLACEMENT_DOM_HP_DESKTOP && LENGTH.message}
                onChange={(event) => {
                  // let targetSource = Object.assign({ DURATION: { DESKTOP: { MIN: { DOM: 6, INTL: 6 }, MAX: { DOM: 30, INTL: 30 } }, MOBILE: { MIN: { DOM: 6, INTL: 6 }, MAX: { DOM: 30, INTL: 30 } } } }, source)
                  console.log('--- SOURCE --- ', source)
                  const value = event.target.value
                  // PREBID.VENDOR.IX.VIDEO.DESKTOP.MIN.DOM = value
                  // targetSource.DESKTOP.MIN.DOM = value
                  source.DOM = source.DOM || {}
                  source.DOM.DESKTOP = source.DOM.DESKTOP || {}                  
                  source.DOM.DESKTOP.HP = value
                  // const newOptions = { ...options}
                  setErrors({ ...errors, PREBID_PLACEMENT_DOM_HP_DESKTOP: value.length < LENGTH.min || value.length > LENGTH.max })
                  setOptions({ ...options })
                  setAllOptions({ ...allOptions })
                }}
                inputProps={{
                  type: 'string',
                  min: 1,
                  max: 15
                }}
              />
            </TableCell>
            <TableCell style={{ textAlign: 'center' }}>
              <TextField
                margin='none'
                value={source.DOM?.DESKTOP?.ROS || ''}
                error={errors.PREBID_PLACEMENT_DOM_ROS_DESKTOP}
                helperText={errors.PREBID_PLACEMENT_DOM_ROS_DESKTOP && LENGTH.message}
                onChange={(event) => {
                  // let targetSource = Object.assign({ DURATION: { DESKTOP: { MIN: { DOM: 6, INTL: 6 }, MAX: { DOM: 30, INTL: 30 } }, MOBILE: { MIN: { DOM: 6, INTL: 6 }, MAX: { DOM: 30, INTL: 30 } } } }, source)
                  console.log('--- SOURCE --- ', source)
                  const value = event.target.value
                  // PREBID.VENDOR.IX.VIDEO.DESKTOP.MIN.DOM = value
                  // targetSource.DESKTOP.MIN.DOM = value
                  source.DOM = source.DOM || {}
                  source.DOM.DESKTOP = source.DOM.DESKTOP || {}                  
                  source.DOM.DESKTOP.ROS = value
                  // const newOptions = { ...options}
                  setErrors({ ...errors, PREBID_PLACEMENT_DOM_ROS_DESKTOP: value.length < LENGTH.min || value.length > LENGTH.max })
                  setOptions({ ...options })
                  setAllOptions({ ...allOptions })
                }}
                inputProps={{
                  type: 'string',
                  min: 1,
                  max: 15
                }}
              />
            </TableCell>
            <TableCell style={{ textAlign: 'center' }}>
              <TextField
                margin='none'
                value={source.INTL?.DESKTOP?.HP || ''}
                error={errors.PREBID_PLACEMENT_INTL_HP_DESKTOP}
                helperText={errors.PREBID_PLACEMENT_INTL_HP_DESKTOP && LENGTH.message}
                onChange={(event) => {
                  // let targetSource = Object.assign({ DURATION: { DESKTOP: { MIN: { DOM: 6, INTL: 6 }, MAX: { DOM: 30, INTL: 30 } }, MOBILE: { MIN: { DOM: 6, INTL: 6 }, MAX: { DOM: 30, INTL: 30 } } } }, source)
                  console.log('--- SOURCE --- ', source)
                  const value = event.target.value
                  // PREBID.VENDOR.IX.VIDEO.DESKTOP.MIN.DOM = value
                  // targetSource.DESKTOP.MIN.DOM = value
                  source.INTL = source.INTL || {}
                  source.INTL.DESKTOP = source.INTL.DESKTOP || {}                  
                  source.INTL.DESKTOP.HP = value
                  // const newOptions = { ...options}
                  setErrors({ ...errors, PREBID_PLACEMENT_INTL_HP_DESKTOP: value.length < LENGTH.min || value.length > LENGTH.max })
                  setOptions({ ...options })
                  setAllOptions({ ...allOptions })
                }}
                inputProps={{
                  type: 'string',
                  min: 1,
                  max: 15
                }}
              />
            </TableCell>
            <TableCell style={{ textAlign: 'center' }}>
              <TextField
                margin='none'
                value={source.INTL?.DESKTOP?.ROS || ''}
                error={errors.PREBID_PLACEMENT_INTL_ROS_DESKTOP}
                helperText={errors.PREBID_PLACEMENT_INTL_ROS_DESKTOP && LENGTH.message}
                onChange={(event) => {
                  // let targetSource = Object.assign({ DURATION: { DESKTOP: { MIN: { DOM: 6, INTL: 6 }, MAX: { DOM: 30, INTL: 30 } }, MOBILE: { MIN: { DOM: 6, INTL: 6 }, MAX: { DOM: 30, INTL: 30 } } } }, source)
                  console.log('--- SOURCE --- ', source)
                  const value = event.target.value
                  // PREBID.VENDOR.IX.VIDEO.DESKTOP.MIN.DOM = value
                  // targetSource.DESKTOP.MIN.DOM = value
                  source.INTL = source.INTL || {}
                  source.INTL.DESKTOP = source.INTL.DESKTOP || {}                  
                  source.INTL.DESKTOP.ROS = value
                  // const newOptions = { ...options}
                  setErrors({ ...errors, PREBID_PLACEMENT_INTL_ROS_DESKTOP: value.length < LENGTH.min || value.length > LENGTH.max })
                  setOptions({ ...options })
                  setAllOptions({ ...allOptions })
                }}
                inputProps={{
                  type: 'string',
                  min: 1,
                  max: 15
                }}
              />

            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell style={{ width: '180px' }}><Typography variant='h6' style={{ fontWeight: 'normal' }}>Mobile</Typography></TableCell>
            <TableCell style={{ textAlign: 'center' }}>
              <TextField
                margin='none'
                value={source.DOM?.MOBILE?.HP || ''}
                error={errors.PREBID_PLACEMENT_DOM_HP_MOBILE}
                helperText={errors.PREBID_PLACEMENT_DOM_HP_MOBILE && LENGTH.message}
                onChange={(event) => {
                  // let targetSource = Object.assign({ DURATION: { DESKTOP: { MIN: { DOM: 6, INTL: 6 }, MAX: { DOM: 30, INTL: 30 } }, MOBILE: { MIN: { DOM: 6, INTL: 6 }, MAX: { DOM: 30, INTL: 30 } } } }, source)
                  console.log('--- SOURCE --- ', source)
                  const value = event.target.value
                  // PREBID.VENDOR.IX.VIDEO.DESKTOP.MIN.DOM = value
                  // targetSource.DESKTOP.MIN.DOM = value
                  source.DOM = source.DOM || {}
                  source.DOM.MOBILE = source.DOM.MOBILE || {}                  
                  source.DOM.MOBILE.HP = value
                  // const newOptions = { ...options}
                  setErrors({ ...errors, PREBID_PLACEMENT_DOM_HP_MOBILE: value.length < LENGTH.min || value.length > LENGTH.max })
                  setOptions({ ...options })
                  setAllOptions({ ...allOptions })
                }}
                inputProps={{
                  type: 'string',
                  min: 1,
                  max: 15
                }}
              />
            </TableCell>
            <TableCell style={{ textAlign: 'center' }}>
              <TextField
                margin='none'
                value={source.DOM?.MOBILE?.ROS || ''}
                error={errors.PREBID_PLACEMENT_DOM_ROS_MOBILE}
                helperText={errors.PREBID_PLACEMENT_DOM_ROS_MOBILE && LENGTH.message}
                onChange={(event) => {
                  // let targetSource = Object.assign({ DURATION: { DESKTOP: { MIN: { DOM: 6, INTL: 6 }, MAX: { DOM: 30, INTL: 30 } }, MOBILE: { MIN: { DOM: 6, INTL: 6 }, MAX: { DOM: 30, INTL: 30 } } } }, source)
                  console.log('--- SOURCE --- ', source)
                  const value = event.target.value
                  // PREBID.VENDOR.IX.VIDEO.DESKTOP.MIN.DOM = value
                  // targetSource.DESKTOP.MIN.DOM = value
                  source.DOM = source.DOM || {}
                  source.DOM.MOBILE = source.DOM.MOBILE || {}                  
                  source.DOM.MOBILE.ROS = value
                  // const newOptions = { ...options}
                  setErrors({ ...errors, PREBID_PLACEMENT_DOM_ROS_MOBILE: value.length < LENGTH.min || value.length > LENGTH.max })
                  setOptions({ ...options })
                  setAllOptions({ ...allOptions })
                }}
                inputProps={{
                  type: 'string',
                  min: 1,
                  max: 15
                }}
              />
            </TableCell>
            <TableCell style={{ textAlign: 'center' }}>
              <TextField
                margin='none'
                value={source.INTL?.MOBILE?.HP || ''}
                error={errors.PREBID_PLACEMENT_INTL_HP_MOBILE}
                helperText={errors.PREBID_PLACEMENT_INTL_HP_MOBILE && LENGTH.message}
                onChange={(event) => {
                  // let targetSource = Object.assign({ DURATION: { DESKTOP: { MIN: { DOM: 6, INTL: 6 }, MAX: { DOM: 30, INTL: 30 } }, MOBILE: { MIN: { DOM: 6, INTL: 6 }, MAX: { DOM: 30, INTL: 30 } } } }, source)
                  console.log('--- SOURCE --- ', source)
                  const value = event.target.value
                  // PREBID.VENDOR.IX.VIDEO.DESKTOP.MIN.DOM = value
                  // targetSource.DESKTOP.MIN.DOM = value
                  source.INTL = source.INTL || {}
                  source.INTL.MOBILE = source.INTL.MOBILE || {}                  
                  source.INTL.MOBILE.HP = value
                  // const newOptions = { ...options}
                  setErrors({ ...errors, PREBID_PLACEMENT_INTL_HP_MOBILE: value.length < LENGTH.min || value.length > LENGTH.max })
                  setOptions({ ...options })
                  setAllOptions({ ...allOptions })
                }}
                inputProps={{
                  type: 'string',
                  min: 1,
                  max: 15
                }}
              />
            </TableCell>
            <TableCell style={{ textAlign: 'center' }}>
              <TextField
                margin='none'
                value={source.INTL?.MOBILE?.ROS || ''}
                error={errors.PREBID_PLACEMENT_INTL_ROS_MOBILE}
                helperText={errors.PREBID_PLACEMENT_INTL_ROS_MOBILE && LENGTH.message}
                onChange={(event) => {
                  // let targetSource = Object.assign({ DURATION: { DESKTOP: { MIN: { DOM: 6, INTL: 6 }, MAX: { DOM: 30, INTL: 30 } }, MOBILE: { MIN: { DOM: 6, INTL: 6 }, MAX: { DOM: 30, INTL: 30 } } } }, source)
                  console.log('--- SOURCE --- ', source)
                  const value = event.target.value
                  // PREBID.VENDOR.IX.VIDEO.DESKTOP.MIN.DOM = value
                  // targetSource.DESKTOP.MIN.DOM = value
                  source.INTL = source.INTL || {}
                  source.INTL.MOBILE = source.INTL.MOBILE || {}                  
                  source.INTL.MOBILE.ROS = value
                  // const newOptions = { ...options}
                  setErrors({ ...errors, PREBID_PLACEMENT_INTL_ROS_MOBILE: value.length < LENGTH.min || value.length > LENGTH.max })
                  setOptions({ ...options })
                  setAllOptions({ ...allOptions })
                }}
                inputProps={{
                  type: 'string',
                  min: 1,
                  max: 15
                }}
              />

            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </>
  )
}
